var React = require('react');

function FirstSmartphoneShadowInline (props) {
    return React.createElement("svg",props,React.createElement("filter",{"id":"drop-shadow","y":"-40%","height":"180%","x":"-40%","width":"180%"},React.createElement("feDropShadow",{"dx":"5","dy":"40","stdDeviation":"40","floodOpacity":"0.5"})));
}

FirstSmartphoneShadowInline.defaultProps = {"width":"0","height":"0","style":{"position":"absolute"}};

module.exports = FirstSmartphoneShadowInline;

FirstSmartphoneShadowInline.default = FirstSmartphoneShadowInline;
